// --------------------------------------------------------------
// Created On: 2024-06-20
// Author: Hannah Vaughan
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment, useEffect, useState } from "react";
import styles from "./NavigationDrawerCollection.module.scss";

export default function NavigationDrawerCollection(props: Props): Component {
  const [selected, setSelected] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<boolean>(false);

  useEffect(() => {
    const isValidSingleTarget = typeof props.targetPage === "string" && props.currentPage === props.targetPage;
    const isValidMultipleTargets = Array.isArray(props.targetPage) && props.targetPage.includes(props.currentPage);
    if (isValidSingleTarget || isValidMultipleTargets) {
      setSelected(true);
      setExpanded(true);
    } else {
      setSelected(false);
      setExpanded(false);
    }
  }, [props.targetPage, props.currentPage]);

  return (
    <div className={styles.body}>
      <div
        className={`${styles.link} ${selected ? styles.selected : ""} ${expanded ? styles.expanded : ""}`}
        onClick={() => setExpanded((previousExpanded) => !previousExpanded)}
        data-test="nav-drawer-collection"
      >
        <div className={styles.item}>
          <i className={`fa fa-fw fa-${props.icon} me-3`} />
          <span>{props.name}</span>
          <span className="pull-right">
            <i className={`fa fa-fw fa-caret-${expanded ? "down" : "right"}`} />
          </span>
        </div>
      </div>
      {expanded && <Fragment>{props.children}</Fragment>}
    </div>
  );
}

interface Props {
  name: string;
  icon: string;
  targetPage: string | string[];
  currentPage: string;
  children: Component | Component[];
}
